import { cn } from '@/utils'

interface UserBubbleProps {
  text: string
  // An email for a teammate, or null for the viewer's own message or an
  // unknown sender (no label shown).
  sender?: string | null
  className?: string
}

export default function UserBubble({
  text,
  sender,
  className,
}: UserBubbleProps) {
  return (
    <div className={cn('flex flex-col items-end', className)}>
      {sender && (
        <span className="mb-0.5 max-w-[80%] truncate px-1 text-[11px] text-muted-foreground">
          {sender}
        </span>
      )}
      <div className="max-w-[80%] rounded-2xl bg-primary px-4 py-2 text-sm text-primary-foreground">
        <p className="whitespace-pre-wrap leading-relaxed">{text}</p>
      </div>
    </div>
  )
}
